import { createAction, createReducer } from 'deox';

export interface MembershipValidation {
  validationStatus: string | null;
}

export interface MembershipValidationState {
  entity: MembershipValidation;
}

export const defaultState: MembershipValidationState = {
  entity: { validationStatus: null },
};

export const mergeMembershipValidation = createAction(
  'MERGE_MEMBERSHIP_VALIDATION',
  resolve => (data: MembershipValidation) => resolve(data),
);

export const membershipValidationReducer = createReducer(
  defaultState,
  handleAction => [
    handleAction(mergeMembershipValidation, (state, { payload: data }) => {
      return {
        ...state,
        entity: {
          ...state.entity,
          ...data,
        },
      };
    }),
  ],
);

export interface MountedState {
  membershipValidation: ReturnType<typeof membershipValidationReducer>;
}

export const selectMembershipValidation = (
  state: MountedState,
): MembershipValidation => state.membershipValidation.entity;

export default membershipValidationReducer;
